import React, { useState, useEffect } from "react";
import MainLayout from "layouts/Main";
import { Typography, Box, FormControl } from "@mui/material";
import Select from "components/Select";
import { useNavigate, useLocation } from "react-router-dom";
import { ProtectedPaths } from "routes";

const ClientReports = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getCurrentView = () => {
    if (location.pathname.includes("/summary")) {
      return "summary";
    } else if (location.pathname.includes("/forecast")) {
      return "forecast";
    }
    return "summary";
  };

  const [selectedView, setSelectedView] = useState(getCurrentView());

  useEffect(() => {
    if (location.pathname === `/${ProtectedPaths.ClientReports}`) {
      navigate(`/${ProtectedPaths.ClientReportsSummary}`, { replace: true });
    }
  }, [location.pathname, navigate]);

  const handleViewChange = (event: any) => {
    const newView = event.target.value;
    setSelectedView(newView);

    if (newView === "summary") {
      navigate(`/${ProtectedPaths.ClientReportsSummary}`);
    } else if (newView === "forecast") {
      navigate(`/${ProtectedPaths.ClientReportsForecast}`);
    }
  };

  return (
    <MainLayout>
      <Box display="flex" alignItems="center" gap={2} sx={{ mb: 3 }}>
        <Typography variant="h5">Reports</Typography>
        <FormControl sx={{ minWidth: 200 }}>
          <Select
            label="View"
            id="report-view"
            name="reportView"
            value={selectedView}
            onChange={handleViewChange}
            options={[
              { label: "Summary", value: "summary" },
              { label: "Forecast", value: "forecast" },
            ]}
          />
        </FormControl>
      </Box>
    </MainLayout>
  );
};

export default ClientReports;
